export default __webpack_public_path__ + "static/media/vip9.4b6d282e.gif";